import type { ComponentProps } from 'react';

import { Flex, Text } from '@aia/ui/atoms';
import { AlertTriangleIcon, type LucideIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

interface FormErrorSummaryProps extends ComponentProps<typeof Flex> {
  icon?: LucideIcon;
}

export function FormErrorSummary({
  children,
  className,
  icon,
  ...props
}: FormErrorSummaryProps): React.ReactElement {
  const IconComponent = icon ?? AlertTriangleIcon;

  return (
    <Flex
      direction="row"
      gap={2}
      alignItems="start"
      className={twMerge('bg-rose-100 text-red-600 p-2 rounded-md', className)}
      {...props}
    >
      <IconComponent size={20} strokeWidth={1.6} />
      <Text>{children}</Text>
    </Flex>
  );
}
